import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

export const PopupWrapper = styled(animated.div)`
  display: flex;
  flex-direction: column;
  position: fixed;
  background-color: ${({ theme, $lightMode }) =>
    $lightMode ? theme.colors.white : theme.colors.standardComponentBackground};
  border-radius: 10px;
  border: 2px solid ${({ theme }) => theme.colors.hoverGrey};
  opacity: 1;
  top: ${({ top }) => `${top}px`};
  left: ${({ left }) => `${left}px`};
  min-width: ${({ $minWidth }) => `${$minWidth}px`};
  z-index: 9;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ border }) => (border ? 0 : '10px')};
`;

export const Arrow = styled.div`
  border-color: ${({ theme, flip }) =>
    `${!flip ? theme.colors.hoverGrey : ''} ${theme.colors.transparent} ${theme.colors.transparent} ${flip ? theme.colors.hoverGrey : ''}`};

  ${({ flip }) => css`
    ${flip ? 'top: -15px;' : 'bottom: -15px'};
  `}

  left: ${({ left }) => (left ? `${left}px` : '50%')};
  margin-left: -7px;
  border-style: solid;
  border-width: 7px;
  height: 0;
  position: absolute;
  width: 0;
`;

export const MenuItem = styled.button`
  align-items: center;
  color: ${({ theme, $lightMode }) => ($lightMode ? theme.colors.standardComponentBackground : theme.colors.white)};
  display: flex;
  opacity: 0.8;
  transition:
    opacity 0.2s ease,
    background-color 0.2s ease;
  background-color: ${({ theme, selected }) => (selected ? theme.colors.black_1 : theme.colors.transparent)};
  border: none;
  border-top: 1px solid
    ${({ theme, border, first }) => (border && !first ? theme.colors.hoverGrey : theme.colors.transparent)};
  padding: ${({ border }) => (border ? '10px' : '0 10px 0 0')};
  border-radius: 5px;
  width: ${({ isPassword }) => (isPassword ? 'auto' : '100%')};

  &:hover,
  &:focus {
    opacity: 1;
    transition:
      opacity 0.2s ease,
      background-color 0.2s ease;
    background-color: ${({ theme, $lightMode }) => ($lightMode ? theme.colors.organizationGreen : theme.colors.black)};
  }
`;

export const Icon = styled.img`
  height: 13px;
  margin: 10px;
  width: 16px;
`;

export const Label = styled.span``;

export const MenuItemWrapper = styled.div`
  display: flex;
`;

export const PasswordInputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  width: ${({ selected }) => (selected ? '100%' : 0)};
  height: 34px;
  transition: width 0.5s ease;
`;

export const PasswordInput = styled.input`
  background-color: ${({ theme }) => theme.colors.transparent};
  border: none;
  outline: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
  color: ${({ theme }) => theme.colors.white_7};
  padding: 0;
  width: 100%;
`;

export const ConfirmButton = styled.button`
  display: ${({ selected }) => (selected ? 'flex' : 'none')};
  background-image: url('/assets/images/theme-2/icons/toolbar/close.svg');
  background-repeat: no-repeat;
  background-size: 13px 13px;
  background-position: center;
  background-color: ${({ theme }) => theme.colors.transparent};
  border: none;
  outline: none;
  width: 34px;
  height: 34px;
  opacity: ${({ disabled }) => (disabled ? '0.5' : '0.8')};
  transition:
    opacity 0.2s ease,
    display 0.5s ease;

  &:hover,
  &:focus {
    opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
    transition: opacity 0.2s ease;
  }
`;
